// src/hooks/useSession.js
import { useState, useCallback } from 'react';
import { fetchMessagesWithToken, persistMessageWithToken } from '../api/ai';

const STORAGE_KEY = 'ai_session_id';

export function useSession(getToken) {
  // مقدار اولیه را از localStorage می‌خوانیم – اگر وجود نداشت، یک UUID جدید می‌سازیم و ذخیره می‌کنیم
  const getInitialSessionId = () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    const newId = crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`;
    localStorage.setItem(STORAGE_KEY, newId);
    return newId;
  };

  const [sessionId, setSessionIdState] = useState(getInitialSessionId);
  const [sessionFull, setSessionFull] = useState(false);

  // تابع کمکی برای به‌روزرسانی هم‌زمان state و localStorage
  const updateSessionId = useCallback((newId) => {
    localStorage.setItem(STORAGE_KEY, newId);
    setSessionIdState(newId);
  }, []);

  // شروع یک سشن کاملاً جدید (با کلیک کاربر)
  const startNewSession = useCallback(() => {
    const newId = crypto.randomUUID ? crypto.randomUUID() : `session-${Date.now()}`;
    updateSessionId(newId);
    setSessionFull(false);
    return newId;
  }, [updateSessionId]);

  // بارگذاری پیام‌های یک سشن خاص
  const loadSessionMessages = useCallback(async (sid) => {
    const token = getToken();
    if (!token) return [];
    try {
      const data = await fetchMessagesWithToken(token, sid);
      return (Array.isArray(data) ? data : []).map(msg => ({
        id: msg.id,
        role: msg.role,
        content: msg.content,
        thinkingSteps: [],
        cards: null,
      }));
    } catch {
      return [];
    }
  }, [getToken]);

  // ذخیره پیام در سرور
  const persistMessage = useCallback(async (role, content) => {
    const token = getToken();
    if (!token) return;
    try {
      await persistMessageWithToken(token, { session_id: sessionId, role, content });
    } catch (e) {
      console.error('Persist error', e);
      throw e;
    }
  }, [sessionId, getToken]);

  return {
    sessionId,
    setSessionId: updateSessionId,   // جایگزین تابع قبلی – هم state هم localStorage
    sessionFull,
    setSessionFull,
    startNewSession,
    loadSessionMessages,
    persistMessage,
  };
}